export default {
  table: state => {
    return state.table;
  },
  tab: state => {
    return state.tab;
  },
  renderDetail: state => {
    return state.renderDetail;
  },
  detailData: state => {
    return state.detailData;
  },
  tabActive: state => {
    return state.tabActive;
  },
  id_user: state => {
    return state.id_user;
  },
  page: state => {
    return state.page;
  },
  column: state => {
    return state.column;
  },
  data: state => {
    return state.data;
  },
  sidebar: state => {
    let x = false;
    if (state.page.type === "setting") {
      x = true;
    } else {
      x = false;
    }
    return x;
  },
  language: state => {
    return state.language;
  },
  banner: state => {
    return state.banner;
  },
  start_end: state => {
    return state.start_end;
  },
  isPublish: state => {
    return state.isPublish;
  },
  content: state => {
    return state.content;
  },
  type: state => {
    return state.type;
  },
  info: state => {
    return state.info;
  },

  activePage: state => {
    return state.activePage;
  },
  choice: state => {
    return state.choice;
  },
  editPage: state => {
    return state.editPage;
  },
  pointer: state => {
    return state.pointer;
  },
  countdown: state => {
    return state.countdown;
  },
  token: state => {
    return state.token;
  },
  userinfo: state => {
    return state.userinfo;
  }
};
